"use client";
import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import logo from "../../../../assets/images/logo.png";
import MainIcon from "../../../../assets/images/logo.png";
// import MainIcon from "../../../../assets/logo.svg";
import { MenuLink, MobileMainMenu, DrawerBox, DrawerDivider, MenuButton, Imagedata, MobileDrawerBox, MobileDrawerHeader, MobileMenuList, MobileCTAButton } from "../styles";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Container, Typography } from "@mui/material";
import styled from "@emotion/styled";
const MobileWrapper = styled.div`
background-color: #000000;
padding: 0px 6px;
border-radius: 22px;
box-shadow: 0 6px 18px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.02);
/* max-width: 1000px; */
margin: 12px auto;
animation: lockerDrop 0.8s cubic-bezier(0.18, 0.9, 0.22, 1.12) both;

@keyframes lockerDrop {
  0% {
    opacity: 0;
    transform: translateY(-72px) scale(0.96);
    filter: blur(8px);
  }

  72% {
    opacity: 1;
    transform: translateY(6px) scale(1.01);
    filter: blur(0);
  }

  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  animation: none;
}

 @media (min-width: 1200px) {
    display: none;
  }

`;
const MobileMenuButton = styled(MenuButton)`
  background: transparent !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  box-shadow: none !important;
  border-radius: 10px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  svg{ color: #fff !important; }
`;
const MobileMenu = (props) => {
  const [state, setState] = useState({ left: false });
  
  const toggleDrawer = (anchor, open) => (event) => {
    // console.log('thest: ', anchor + " : " +open)
    if ( event.type === "keydown" && (event.key === "Tab" || event.key === "Shift") ){return;}
    setState({ ...state, [anchor]: open });
  };
  return (
    <MobileWrapper>
        <Container maxWidth='xl'>
    <MobileMainMenu>
      <MenuLink href="/" p="15px 0 15px">
        <Imagedata src={logo} alt=""  mw="40px" />
      </MenuLink>
      <MobileMenuButton onClick={toggleDrawer("left", true)}>
        {state["left"] ? (
          <CloseIcon />
        ) : (
          <MenuIcon />
        )}
      </MobileMenuButton>
      <Drawer anchor="left" open={state["left"]} onClose={toggleDrawer("left", false)}>
        <MobileDrawerBox role="presentation">
          <MobileDrawerHeader>
            <MenuLink href="/">
              <Imagedata src={MainIcon} alt="" mw="56px" />
            </MenuLink>
            <div style={{display:'flex',gap:12,alignItems:'center'}}>
              <MobileCTAButton href="https://zephyrbrowser/browser/zephyr-1.0.0.exe">
                <span className="default-label">Download Now</span>
                {/* <span className="hover-label">Coming Soon</span> */}
              </MobileCTAButton>
              <IconButton onClick={toggleDrawer("left", false)} sx={{color:'#fff'}} aria-label="close">
                <CloseIcon />
              </IconButton>
            </div>
          </MobileDrawerHeader>

          <Divider sx={{width:"100%",height:"2px", background:"#fff"}}/>

     <MobileMenuList>
  {props.menuList
    .filter((item) => typeof item.title === "string")
    .map((value, i) => (
      <MenuLink
        key={i}
        href={value.link}
        Zidex={value.zindex}
        target={value.target}
        className={`${value.customClass || ""} d-block`}
        p="18px 0"
        sx={{ fontSize: 20 }}
        onClick={toggleDrawer("left", false)}
      >
        {value.title}
      </MenuLink>
    ))}
</MobileMenuList>
        </MobileDrawerBox>
      </Drawer>
    </MobileMainMenu>
    </Container>
    </MobileWrapper>
  );
}

export default MobileMenu;

